var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { Event, NotificationType } from "../models/enums.js";
import { DataStore } from "../services/datastore.service.js";
import { EventBus } from "../services/eventbus.service.js";
import { System } from "../services/system.service.js";
import Utils from "../utils/utils.js";
let AppUser = class AppUser extends LitElement {
    constructor() {
        super();
        this._confirm = "";
        this._validEmail = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        this._endpoint = undefined;
        this.subscriptions = [];
        this._nameu = {
            firstname: "",
            lastname: "",
        };
        this.editName = false;
        this.validnewname = false;
        this.loadingName = false;
        this.notificationtypeName = NotificationType.INFO;
        this.notificationName = undefined;
        this.notificationtimeName = "";
        this._emailu = {
            email: "",
        };
        this.editEmail = false;
        this.validemail = false;
        this.loadingEmail = false;
        this.notificationtypeEmail = NotificationType.INFO;
        this.notificationEmail = undefined;
        this.notificationtimeEmail = "";
        this._pwu = {
            password: "",
            current: "",
        };
        this.validnewpassword = false;
        this.loadingPw = false;
        this.notificationtypePw = NotificationType.INFO;
        this.notificationPw = undefined;
        this.notificationtimePw = "";
        this.keydownHandler = (e) => {
            if (e.keyCode == 13) {
                if (this.editName && this.validnewname) {
                    this.updateName();
                }
                if (this.editEmail && this.validemail) {
                    this.updateEmail();
                }
                if (this.validnewpassword) {
                    this.updatePassword();
                }
            }
        };
        this.keyupHandler = () => {
            this.updateNameValues();
            this.updateEmailValues();
            this.updatePasswordValues();
        };
        this.datastore = DataStore.getInstance();
        this.eventbus = EventBus.getInstance();
        this.system = System.getInstance();
    }
    connectedCallback() {
        super.connectedCallback();
        this.datastore.verifyPageAccess(window.location.pathname);
        window.addEventListener("keydown", this.keydownHandler);
        window.addEventListener("keyup", this.keyupHandler);
        this.eventbus.addEventListener(Event.RequestUpdate, (_event) => {
            this.requestUpdate();
        });
    }
    disconnectedCallback() {
        window.removeEventListener("keydown", this.keydownHandler);
        window.removeEventListener("keyup", this.keyupHandler);
        super.disconnectedCallback();
    }
    createRenderRoot() {
        return this;
    }
    updateNameValues() {
        this.validnewname = false;
        const eFirstname = document.getElementById("firstname");
        const eLastname = document.getElementById("lastname");
        if (this.editName && eFirstname !== null) {
            this._nameu.firstname = eFirstname.value;
            this._nameu.lastname = eLastname.value;
            this.validnewname = true;
            if (this._nameu.firstname.length < 1 || this._nameu.lastname.length < 1) {
                this.validnewname = false;
            }
            if (this._nameu.firstname === this.datastore.user?.firstname && this._nameu.lastname === this.datastore.user.lastname) {
                this.validnewname = false;
            }
        }
    }
    updateName() {
        this.loadingName = true;
        this.datastore
            .updateName(this._nameu)
            .then(() => {
            this.setNotificationName(NotificationType.SUCCESS, "Name updated");
            this.editName = false;
            this.requestUpdate();
        })
            .catch((error) => {
            this.setNotificationName(NotificationType.DANGER, JSON.parse(error.body).errortext);
            this.requestUpdate();
        })
            .finally(() => (this.loadingName = false));
    }
    updateEmailValues() {
        if (this.editEmail) {
            this._emailu.email = document.getElementById("newemail").value;
            this.validemail = this.isEmail(this._emailu.email) && this._emailu.email !== this.datastore.user?.email;
        }
    }
    updateEmail() {
        this.loadingEmail = true;
        this.datastore
            .updateEmail(this._emailu)
            .then(() => {
            this.setNotificationEmail(NotificationType.SUCCESS, "Email update request sent - check new email to verify");
            this.editEmail = false;
            this.requestUpdate();
        })
            .catch((error) => {
            this.setNotificationEmail(NotificationType.DANGER, JSON.parse(error.body).errortext);
            this.requestUpdate();
        })
            .finally(() => (this.loadingEmail = false));
    }
    isEmail(search) {
        let valid;
        valid = this._validEmail.test(search);
        return valid;
    }
    updatePasswordValues() {
        this._pwu.password = document.getElementById("password").value;
        this._pwu.current = document.getElementById("current").value;
        this._confirm = document.getElementById("confirm").value;
        this.validnewpassword = true;
        if (this._confirm !== this._pwu.password) {
            this.validnewpassword = false;
        }
        if (this._confirm.length < 4) {
            this.validnewpassword = false;
        }
    }
    updatePassword() {
        this.loadingPw = true;
        this.datastore
            .updatePassword(this._pwu)
            .then((_) => {
            document.getElementById("password").value = "";
            document.getElementById("current").value = "";
            document.getElementById("confirm").value = "";
            this.updatePasswordValues();
            this.setNotificationPw(NotificationType.SUCCESS, "Password updated");
            this.requestUpdate();
        })
            .catch((error) => {
            this.setNotificationPw(NotificationType.DANGER, JSON.parse(error.body).errortext);
            this.requestUpdate();
        })
            .finally(() => (this.loadingPw = false));
    }
    setNotificationName(type, text) {
        this.notificationtypeName = type;
        this.notificationName = text;
        this.notificationtimeName = Utils.utcDateString();
    }
    setNotificationEmail(type, text) {
        this.notificationtypeEmail = type;
        this.notificationEmail = text;
        this.notificationtimeEmail = Utils.utcDateString();
    }
    setNotificationPw(type, text) {
        this.notificationtypePw = type;
        this.notificationPw = text;
        this.notificationtimePw = Utils.utcDateString();
    }
    clearNotification() {
        this.notificationName = undefined;
        this.notificationEmail = undefined;
        this.notificationPw = undefined;
        this.requestUpdate();
    }
    async requestWebpush() {
        if (this.system.webPushAllowed()) {
            this.eventbus.dispatchInfo("Notifications already allowed", "fas fa-comment");
            return;
        }
        this.datastore.addLog("webpush requesting access");
        await this.system.webPushRequest();
        this.requestUpdate();
    }
    async subscribe() {
        this.datastore.addLog("webpush subscribing");
        this.datastore.webpushSubscribe()
            .then((_) => {
            this.fetchData();
        });
    }
    unsubscribe() {
        this.datastore.addLog("webpush unsubscribing");
        this.datastore.webpushUnsubscribe()
            .then((_) => {
            this.subscriptions = this.subscriptions.filter((sub) => sub.notificationEndPoint !== this._endpoint);
            this._endpoint = undefined;
            this.requestUpdate();
        });
    }
    subscriptionDelete(endpoint) {
        this.datastore.webpushSubscriptionDelete(endpoint)
            .then((_) => {
            this.fetchData();
        });
    }
    fetchData() {
        navigator.serviceWorker.ready.then((reg) => {
            reg.pushManager.getSubscription()
                .then((subscription) => {
                if (subscription) {
                    this._endpoint = subscription.endpoint;
                }
            });
        });
        this.datastore.webpushSubscriptions()
            .then((list) => {
            this.subscriptions = list;
            this.requestUpdate();
        })
            .catch((error) => {
            this.requestUpdate();
            this.eventbus.dispatchError(error);
        });
    }
    firstUpdated() {
        this.fetchData();
    }
    render() {
        return html `
            <div class="card fade-in">
                <div class="card-content">
                    <div class="grid is-col-min-12">
                        <div class="cell">
                            <article class="notification is-info">
                                ${this.editName ? html `
                                    <div class="field">
                                        <div class="control has-icons-left has-icons-right">
                                            <input id="firstname" class="input" type="text" value="${this.datastore.user.firstname}" placeholder="Firstname" @change=${this.updateNameValues} />
                                            <span class="icon is-small is-left">
                                                <i class="fas fa-user"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="field">
                                        <div class="control has-icons-left has-icons-right">
                                            <input id="lastname" class="input" type="text" value="${this.datastore.user.lastname}" placeholder="Lastname" @change=${this.updateNameValues} />
                                            <span class="icon is-small is-left">
                                                <i class="fas fa-user"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="field is-grouped">
                                        <div class="control">
                                            <button class="button is-secondary" @click="${this.updateName}" ?disabled=${!this.validnewname}>
                                                <span class="icon">
                                                    ${this.loadingName ? html ` <i class="fas fa-circle-notch fa-spin"></i> ` : html ` <i class="fas fa-save"></i> `}
                                                </span>
                                            </button>
                                        </div>
                                        <div class="control">
                                            <button class="button is-secondary" @click="${() => (this.editName = false)}">
                                                <span class="icon">
                                                    <i class="fas fa-cancel"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                ` : html `
                                    <p class="title"><i class="fas fa-user mr-2"></i>${this.datastore.user?.firstname} ${this.datastore.user?.lastname}</p>
                                    <div class="field is-grouped">
                                        <div class="control">
                                            <button class="button is-secondary"
                                                @click="${() => {
            this.clearNotification();
            this._nameu.firstname = this.datastore.user?.firstname;
            this._nameu.lastname = this.datastore.user?.lastname;
            this.editName = true;
            this.editEmail = false;
            this.updateNameValues();
        }}">
                                                <span class="icon">
                                                    <i class="fas fa-edit"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                `}
                                ${this.notificationName ? html `
                                <div class="notification ${this.notificationtypeName} mt-4 has-text-centered">
                                    <button class="delete" @click="${this.clearNotification}"></button>
                                    <p class="mb-0">${this.notificationName}</p>
                                    <p class="is-size-7">${this.notificationtimeName}</p>
                                </div>
                                ` : ""}
                            </article>
                        </div>
                        <div class="cell">
                            <article class="cell is-child notification is-info">
                                <p class="title"><i class="fas fa-at mr-2"></i>${this.datastore.user?.email}</p>
                                ${this.editEmail ? html `
                                <div class="content">
                                    <div class="field">
                                        <div class="control has-icons-left">
                                            <input id="newemail" class="input" type="email" placeholder="New email" @change=${this.updateEmailValues} />
                                            <span class="icon is-small is-left">
                                                <i class="fas fa-at"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="field is-grouped">
                                        <div class="control">
                                            <button class="button is-secondary" @click="${this.updateEmail}" ?disabled=${!this.validemail}>
                                                <span class="icon">
                                                    ${this.loadingEmail ? html ` <i class="fas fa-circle-notch fa-spin"></i> ` : html ` <i class="fas fa-save"></i> `}
                                                </span>
                                            </button>
                                        </div>
                                        <div class="control">
                                            <button class="button is-secondary" @click="${() => (this.editEmail = false)}">
                                                <span class="icon">
                                                    <i class="fas fa-cancel"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                ` : html `
                                <div class="field is-grouped">
                                    <div class="control">
                                        <button class="button is-secondary"
                                            @click="${() => {
            this.clearNotification();
            this.editName = false;
            this.editEmail = true;
        }}">
                                            <span class="icon">
                                                <i class="fas fa-edit"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                                `}
                                ${this.notificationEmail ? html `
                                <div class="notification ${this.notificationtypeEmail} mt-4 has-text-centered">
                                    <button class="delete" @click="${this.clearNotification}"></button>
                                    <p class="mb-0">${this.notificationEmail}</p>
                                    <p class="is-size-7">${this.notificationtimeEmail}</p>
                                </div>
                                ` : ""}
                            </article>
                        </div>
                        <div class="cell">
                            <article class="cell is-child notification is-warning">
                                <p class="title"><i class="fas fa-lock mr-2"></i>Password</p>
                                <div class="content">
                                    <div class="field">
                                        <div class="control has-icons-left">
                                            <input id="current" class="input" type="password" autocomplete="new-password" placeholder="Existing password" @change=${this.updatePasswordValues} />
                                            <span class="icon is-small is-left">
                                                <i class="fas fa-lock"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="field">
                                        <div class="control has-icons-left">
                                            <input id="password" class="input" type="password" autocomplete="new-password" placeholder="New password" @change=${this.updatePasswordValues} />
                                            <span class="icon is-small is-left">
                                                <i class="fas fa-lock"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="field">
                                        <div class="control has-icons-left">
                                            <input id="confirm" class="input" type="password" autocomplete="new-password" placeholder="Confirm password" @change=${this.updatePasswordValues} />
                                            <span class="icon is-small is-left">
                                                <i class="fas fa-lock"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="field is-grouped">
                                        <div class="control">
                                            <button class="button is-secondary" @click="${this.updatePassword}" ?disabled=${!this.validnewpassword}>
                                                <span class="icon">
                                                    ${this.loadingPw ? html ` <i class="fas fa-circle-notch fa-spin"></i> ` : html ` <i class="fas fa-save"></i> `}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                    ${this.notificationPw ? html `
                                    <div class="notification ${this.notificationtypePw} mt-4 has-text-centered">
                                        <button class="delete" @click="${this.clearNotification}"></button>
                                        <p class="mb-0">${this.notificationPw}</p>
                                        <p class="is-size-7">${this.notificationtimePw}</p>
                                    </div>
                                    ` : ""}
                                </div>
                            </article>
                        </div>

                        ${this.system.webPushAvailable() ? html `
                            <div class="cell">
                                <article class="notification is-info">
                                    <p class="title"><i class="fas fa-comment mr-2"></i>Notifications</p>
                                    <div class="content">
                                        <button class="button is-rounded ${this.system.webPushAllowed() ? 'is-success' : 'is-danger'}" @click="${() => { this.requestWebpush(); }}">
                                        <span class="icon">
                                            <i class="fas fa-comment-dots"></i>
                                        </span>
                                        </button>
                                        ${this.system.webPushAllowed() ? html `
                                            ${this._endpoint ? html `
                                            <button class="button is-success is-rounded ml-3" @click="${() => { this.unsubscribe(); }}">
                                            <span class="icon">
                                                <i class="fas fa-bell"></i>
                                            </span>
                                            </button>
                                            ` : html `
                                            <button class="button is-link is-rounded ml-3" @click="${() => { this.subscribe(); }}">
                                            <span class="icon">
                                                <i class="fas fa-bell"></i>
                                            </span>
                                            </button>
                                            `}
                                        ` : ""}
                                        <br><br>
                                        <table class="table is-narrow is-fullwidth">
                                            ${this.subscriptions.map((sub) => html `
                                            <tr class="is-info">
                                                <td>
                                                    ${this._endpoint === sub.notificationEndPoint ? html `
                                                    <button class="button is-success is-rounded ml-3">
                                                        <span class="icon">
                                                            <i class="fas fa-check"></i>
                                                        </span>
                                                    </button>
                                                    ` : html `
                                                    <button class="button is-danger is-rounded ml-3" @click="${() => { this.subscriptionDelete(sub.notificationEndPoint); }}">
                                                        <span class="icon">
                                                            <i class="fas fa-trash"></i>
                                                        </span>
                                                    </button>
                                                    `}
                                                </td>
                                                <td>${Utils.localDateTimeFormatted(sub.created)} - ${Utils.extractBrowserWithVersion(sub.useragent)}</td>
                                            </tr>
                                            `)}
                                        </table>
                                    </div>
                                </article>
                            </div>
                        ` : ""}

                    </div>
                </div>
                <footer class="card-footer">
                    <span class="card-footer-item is-size-7">version ${this.datastore.version}</span>
                </footer>
            </div>
        `;
    }
};
__decorate([
    state()
], AppUser.prototype, "editName", void 0);
__decorate([
    state()
], AppUser.prototype, "validnewname", void 0);
__decorate([
    state()
], AppUser.prototype, "loadingName", void 0);
__decorate([
    state()
], AppUser.prototype, "editEmail", void 0);
__decorate([
    state()
], AppUser.prototype, "validemail", void 0);
__decorate([
    state()
], AppUser.prototype, "loadingEmail", void 0);
__decorate([
    state()
], AppUser.prototype, "validnewpassword", void 0);
__decorate([
    state()
], AppUser.prototype, "loadingPw", void 0);
AppUser = __decorate([
    customElement("app-user")
], AppUser);
export { AppUser };
//# sourceMappingURL=user_info.js.map